<template>
<div>
  
  <div class="advisory-box">
    <div class="fill-head">
      <img src="../../static/images/fanhui (3).png" alt="" @click="goBlack" />
      <div>IT 咨询</div>
    </div>
    <h5>请填写您的咨询问题，我们将在3~5个工作日内回复您</h5>
    <input placeholder="您的姓名" v-model="name"/>
    <input placeholder="您的手机号" type="number" v-model="phone"/>
    <textarea placeholder="请描述您想咨询的问题（如数字化解决方案、商业模式、产品战略、产品规划、问题诊断、风险预估等）~" v-model="intro"/>
    <div class="add-advisory" @click="addAdvisory">提交咨询</div>
    <div class="prompt-box" v-if="showPrompt">{{promptCont}}</div>
    
    <popup class="m_popup" :userBehavior="confirm"></popup>
  </div>


</div>
</template>

<script>
import Popup from '../../components/common/Popup'

export default {
  data(){
    return{
      name:'',
      phone:'',
      intro:'',
      showPrompt:false,
      promptCont:'提交成功',//提示
      isPopup: false,
      popupData: {
        type: '手机号码填写不规范，请重新填写！',
        message: '提交成功！'
      }

    }
  },
  components: {
    Popup
  },
  methods:{
    goBlack() {
      this.$router.go(-1);
    },
    addAdvisory(){
      let options = {
        username: this.name,
        mobile: this.phone,
        details: this.intro
      }
     
      if('7' > options.mobile.length || options.mobile.length > '12' ) {
        confirm(this.popupData.type)
      }else {
        this.$http.post(
          "https://eartisanapplets.wsandos.com/api/index/consulting",
          options,
          (res) => {
            if(res.code === 1) {
              this.showPrompt = true;
              setTimeout(()=>{
                this.$router.go(-1)
              },1000)
            }
            // console.log("res", res)
          }
        );
      }
    },

    confirm(type, message) {
      this.popupData.type = type;
      this.popupData.message = message;
    }
  }
}
</script>

<style lang="stylus" scoped>
.advisory-box {
  height :100vh;
  padding: 0 0.24rem;
  h5{
    font-size: 0.24rem;
    font-family: PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 0.36rem;
    padding :0.3rem 0 0.1rem;
  }
  input{
    width: 100%;
    height: 0.88rem;
    background: #FFFFFF;
    border: 1px solid #E1E6F0;
    border-radius: 0.1rem;
    padding :0.31rem;
    margin :0.22rem auto 0;
  }
  textarea{
    width: 100%;
    height: 3.6rem;
    background: #FFFFFF;
    border: 1px solid #E1E6F0;
    border-radius: 0.1rem;
    padding :0.29rem 0.22rem;
    margin :0.22rem auto 0;
  }
}

.add-advisory {
  position:fixed;
  bottom :0.45rem;
  width: 94%;
  height: 0.88rem;
  background: #FFC000;
  line-height :0.88rem;
  border-radius: 0.1rem;
  font-size: 0.28rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  text-align:center;
}
.prompt-box{
  display :block;
  position :fixed;
  top :30%;
  left :40%;
  background :rgba(1,1,1,1)
  padding :10px;
  color :#fff;
  border-radius :5%;
}

.fill-head {
  padding-top: 3.6%; 
  display: flex;
}

.fill-head img {
  width: 5.33%;
  height: 5.33%;
}

.fill-head div {
  margin-left: 35%;
  font-size: 0.36rem;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/itAdvisory.vue